import { render, staticRenderFns } from "./QHqPromotionsDrilldown.vue?vue&type=template&id=222a089c&scoped=true&"
import script from "./QHqPromotionsDrilldown.vue?vue&type=script&lang=js&"
export * from "./QHqPromotionsDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222a089c",
  null
  
)

export default component.exports